const quotes = [
  {
    quote: 'Your uniqueness is your superpower.',
    author: 'Chris Packham (naturalist/presenter - autism)'
  },
  {
    quote:
      'Do not judge me by my successes, judge me by how many times I fell down and got back up again.',
    author: 'Richard Branson (Virgin Group founder - dyslexia)'
  },
  {
    quote: "It's not a disability, it's a different ability.",
    author: 'Stuart Duncan ("AutismFather" developer - autism)'
  },
  {
    quote:
      "I don't suffer from autism, but I do suffer from the way you treat me.",
    author: 'Tyler Durdin (autistic self-advocate)'
  },
  {
    quote:
      'I can’t help but feel that some misunderstandings about autism could be resolved if only people would listen to what we have to say.',
    author: 'Naoki Higashida (author - autism)'
  },

  {
    quote: "You don't have to be 'normal' to be happy and successful.",
    author: "John Elder Robison (writer - Asperger's syndrome)"
  },
  {
    quote:
      'The more I give myself permission to live in the moment and enjoy it without feeling guilty or judgmental about any other time, the better I feel.',
    author: 'Ellen Forney (cartoonist and author - bipolar disorder)'
  },
  {
    quote: 'I want to encourage people to be who they are.',
    author: 'Michael McCreary (comedian actor - autism)'
  },
  {
    quote:
      'Everyone has a mountain to climb and autism has not been my mountain, it has been my opportunity for victory.',
    author: 'Rachel Barcellona (autism advocate and pageant titleholder)'
  },

  {
    quote:
      'Autistic people are all unique. I believe it is important to find the beauty.',
    author: 'Erin McKinney (autism advocate)'
  },

  {
    quote:
      'I know we’re not supposed to judge people by their appearances. But people tend to make exceptions for autistic people.',
    author: 'Chris Bonnello (autistic educator and advocate)'
  },

  {
    quote:
      'I might hit developmental and societal milestones in a different order than my peers, but I am able to accomplish these small victories on my own time.',
    author: 'Haley Moss (lawyer and autistic advocate)'
  },
  {
    quote:
      'If you’ve met one individual with autism, you’ve met one individual with autism.',
    author: 'Stephen Shore (professor and autism advocate)'
  },
  {
    quote:
      'Wanting to be free. Wanting to be me. Trying to make people see. And accept the real me.',
    author: 'Scott Lentine (autistic poet and advocate)'
  },
  {
    quote: 'Your talent and determination will speak louder than any words.',
    author: 'Cher (singer - dyslexia)'
  },
  {
    quote:
      'The key to success is embracing your uniqueness and leveraging it to make a difference.',
    author: 'Daniel Tammet (writer - autism)'
  },
  {
    quote:
      'My fear is that if I don’t mask, push through & show how capable I am, I won’t be offered opportunities in the future or be valued the same.',
    author: 'Emily Swiatek (autistic public speaker & advocate)'
  },
  {
    quote:
      'When I was younger I was looking for this magic meaning of life. It’s very simple now. Making the lives of others better, doing something of lasting value. That’s the meaning of life, it’s that simple.',
    author: 'Dr. Temple Grandin (animal scientist - autism)'
  },
  {
    quote:
      'Recognizing and respecting differences in others, and treating everyone like you want them to treat you, will help make our world a better place for everyone.',
    author: 'Kim Peek (mega-savant - savant syndrome)'
  },
  {
    quote:
      'My philosophy is: It’s none of my business what people say of me and think of me. I am what I am, and I do what I do. I expect nothing and accept everything. And it makes life so much easier.',
    author: "Sir Anthony Hopkins (actor - Asperger's syndrome)"
  },
  {
    quote:
      'It does not matter what sixty-six percent of people do in any particular situation. All that matters is what you do.',
    author: 'John Elder Robinson (author - autism)'
  },
  {
    quote: 'The best way to predict the future is to create it.',
    author: 'Bill Gates (Microsoft cofounder - dyslexia &ADHD)'
  },
  {
    quote:
      "Don't compare yourself with anyone in this world. If you do so, you are insulting yourself.",
    author: 'Bill Gates (Microsoft cofounder - dyslexia &ADHD)'
  },
  {
    quote: 'At the end of the day, we don’t dream our lives… WE LIVE THEM!',
    author: 'Anthony Ianni (Autistic former basketball player and advocate)'
  },

  {
    quote:
      'ADHD may bring chaos, but it also brings an incredible ability to hyperfocus and create magic.',
    author: 'will.i.am (musician - ADHD)'
  },
  {
    quote: 'Autism can’t define me. I define autism.',
    author: 'Kerry Magro (autism advocate and speaker)'
  },
  {
    quote:
      'Being different isn’t a bad thing. It means you’re brave enough to be yourself.',
    author: 'Luna Rose (autistic teen author and advocate)'
  },
  {
    quote:
      'I’m a proud person with autism. It’s a part of who I am, and I wouldn’t change it for the world.',
    author: 'Jonathan Rowland (autistic speaker & YouTuber)'
  },
  {
    quote: "Different isn't bad. It's just different, and that can be amazing.",
    author: 'Rosie King (autistic speaker & storyteller)'
  },

  {
    quote: 'Imagination is more important than knowledge.',
    author: 'Albert Einstein (Physicist – suspected ADHD)'
  },
  {
    quote:
      'Try not to become a man of success, but rather try to become a man of value.',
    author: 'Albert Einstein (Physicist – suspected ADHD)'
  },
  {
    quote: 'In the middle of difficulty lies opportunity.',
    author: 'Albert Einstein (Physicist – suspected ADHD)'
  },
  {
    quote:
      'Learn from yesterday, live for today, hope for tomorrow. The important thing is not to stop questioning.',
    author: 'Albert Einstein (Physicist – suspected ADHD)'
  },
  {
    quote:
      'Life is like riding a bicycle. To keep your balance, you must keep moving.',
    author: 'Albert Einstein (Physicist – suspected ADHD)'
  },
  {
    quote: "Don't be afraid to fail. Be afraid not to try.",
    author: 'Simone Biles (Olympic gymnast - ADHD)'
  },
  {
    quote: "Hard days are the best because that's when champions are made.",
    author: 'Simone Biles (Olympic gymnast - ADHD)'
  },
  {
    quote: 'Practice creates confidence. Confidence empowers you.',
    author: 'Simone Biles (Olympic gymnast - ADHD)'
  },
  {
    quote: "Autism is my superpower, what's yours?",
    author: 'Alexa Lauenburger (dog trainer & autism advocate)'
  },
  {
    quote:
      'Routine is a pivotal part of my daily life and any deviation, however slight, can cause great discomfort to me.',
    author: 'Nathan Cornfield (autistic public speaker)'
  },
  {
    quote:
      'I might hit developmental and societal milestones in a different order than my peers, but I am able to accomplish these small victories on my own time.',
    author: 'Haley Moss (autistic lawyer and author)'
  },
  {
    quote:
      'I believe that inside every person who is bullied there is a strength and a tenacity to survive... they, too, can get through this.',
    author: 'Amy Gravino (autistic advocate and author)'
  },
  {
    quote:
      'You are stronger than you think, and you have the power to overcome any challenge.',
    author: 'Cara Delevingne (Model - Dyspraxia & ADHD)'
  },
  {
    quote:
      "Remember to take care of yourself, both physically and mentally. Self-care is not selfish, it's necessary.",
    author: 'Cara Delevingne (Model - Dyspraxia & ADHD)'
  }
];

export default quotes;
